<template>
  <!--====================  header area ====================-->
  <div class="header-area">
    <div class="header-area__desktop header-area__desktop--default">
      <!--=======  header top bar  =======-->
      <div class="header-top-bar">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-4">
              <!-- top bar left -->
              <div class="top-bar-left-wrapper">
                <div
                  class="social-links social-links--white-topbar d-inline-block"
                >
                  <!-- <ul>
                    <li>
                      <a href="//facebook.com" target="_blank"
                        ><i class="zmdi zmdi-facebook"></i
                      ></a>
                    </li>
                    <li>
                      <a href="//twitter.com" target="_blank"
                        ><i class="zmdi zmdi-twitter"></i
                      ></a>
                    </li>
                    <li>
                      <a href="//vimeo.com" target="_blank"
                        ><i class="zmdi zmdi-vimeo"></i
                      ></a>
                    </li>
                    <li>
                      <a href="//linkedin.com" target="_blank"
                        ><i class="zmdi zmdi-linkedin-box"></i
                      ></a>
                    </li>
                    <li>
                      <a href="//skype.com" target="_blank"
                        ><i class="zmdi zmdi-skype"></i
                      ></a>
                    </li>
                  </ul> -->
                </div>
              </div>
            </div>
            <div class="col-lg-8">
              <!-- top bar right -->
              <div class="top-bar-right-wrapper">
                <router-link
                  to="/Contact"
                  class="ht-btn ht-btn--default d-inline-block"
                  >تماس با ما</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--=======  End of header top bar  =======-->

      <!--=======  header info area  =======-->
      <div class="header-info-area">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-12">
              <div class="header-info-wrapper align-items-center">
                <!-- logo -->
                <div class="logo">
                  <router-link to="/">
                    <img
                      :src="$backendPublic + getSettings.logo.value"
                      class="img-fluid"
                      alt="logo"
                    />
                  </router-link>
                </div>

                <!-- header contact info -->
                <div class="header-contact-info">
                  <div class="header-info-single-item">
                    <div class="header-info-single-item__icon">
                      <i class="zmdi zmdi-smartphone-android"></i>
                    </div>
                    <div class="header-info-single-item__content">
                      <h6 class="header-info-single-item__title">تلفن</h6>
                      <p class="header-info-single-item__subtitle">
                        <a :href="'tel:' + getSettings.phone.value">{{
                          getSettings.phone.value
                        }}</a>
                      </p>
                    </div>
                  </div>
                  <div class="header-info-single-item">
                    <div class="header-info-single-item__icon">
                      <i class="zmdi zmdi-home"></i>
                    </div>
                    <div class="header-info-single-item__content">
                      <h6 class="header-info-single-item__title">آدرس</h6>
                      <p class="header-info-single-item__subtitle">
                        {{ getSettings.address.value }}
                      </p>
                    </div>
                  </div>
                </div>

                <!-- mobile menu -->
                <div
                  class="mobile-navigation-icon"
                  id="mobile-menu-trigger"
                  @click="mobiletoggleClass('addClass', 'active')"
                >
                  <i></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--=======  End of header info area =======-->

      <!--=======  header navigation area  =======-->
      <fixed-header>
        <div class="header-navigation-area default-bg">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <!-- header navigation -->
                <div
                  class="header-navigation header-navigation--header-default position-relative"
                >
                  <div class="header-navigation__nav position-static">
                    <nav>
                      <ul>
                        <li
                          v-for="item in getMenuItems"
                          :key="item.id"
                          v-bind:class="{
                            'has-children has-children--multilevel-submenu':
                              item.children.length,
                          }"
                        >
                          <router-link :to="menuItemLink(item)">{{
                            item.name
                          }}</router-link>
                          <ul v-if="item.children.length > 0" class="submenu">
                            <li v-for="child in item.children" :key="child.id">
                              <router-link :to="menuItemLink(child)">{{
                                child.name
                              }}</router-link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fixed-header>
      <!--=======  End of header navigation area =======-->
    </div>
  </div>
  <!--====================  End of header area  ====================-->
</template>

<script>
import FixedHeader from "vue-fixed-header"
import { settingStore } from "@/store/Modules/setting.js"
import { menuItemStore } from "@/store/Modules/menuItem.js"
import { mapState } from "pinia"
import { mapStores } from "pinia"
import { mapActions } from "pinia"

export default {
  components: {
    FixedHeader,
  },

  computed: {
    ...mapState(menuItemStore, ["getMenuItems"]),
    ...mapState(settingStore, ["getSettings"]),
  },
  data: () => ({
    menuItems_loading: true,
  }),
  methods: {
    ...mapActions(menuItemStore, ["getMenuItemsAction"]),
    // offcanvas mobilemenu
    mobiletoggleClass(addRemoveClass, className) {
      const el = document.querySelector("#offcanvas-menu")
      if (addRemoveClass === "addClass") {
        el.classList.add(className)
      } else {
        el.classList.remove(className)
      }
    },
    menuItemLink(item) {
      if (item.type == "internal_link") {
        return item.link
      }
      return "#"
    },
  },

  mounted() {
    EventSys.$on("menuItems_loading", () => (this.menuItems_loading = true))
    EventSys.$on("menuItems_loaded", () => (this.menuItems_loading = false))
    this.getMenuItemsAction()
  },
}
</script>

<style lang="scss">
.vue-fixed-header--isFixed {
  right: 0;
  top: 0;
  width: 100vw;
  z-index: 999;
  position: fixed;
  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.2);
  animation: 900ms cubic-bezier(0.2, 1, 0.22, 1) 0s normal none 1 running
    fadeInDown;
}
</style>
